/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Build_TitleInputs */

const en_mk_build_title = /** @type {(inputs: Mk_Build_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`One plan. Three ways to bring it to life.`)
};

const id_mk_build_title = /** @type {(inputs: Mk_Build_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Satu rencana. Tiga cara mewujudkannya.`)
};

/**
* | output |
* | --- |
* | "One plan. Three ways to bring it to life." |
*
* @param {Mk_Build_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_build_title = /** @type {((inputs?: Mk_Build_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Build_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_build_title(inputs)
	return en_mk_build_title(inputs)
});